<template>
  <div class="p-test-record">
    <template v-if="isTeacher">
      <card-header style="margin-top:20px;">巩固练习记录</card-header>
      <el-radio-group v-model="sourceTab" style="margin: 30px 0;display: block;">
        <el-radio-button class="button--plain" label="name">导出来源: </el-radio-button>
        <el-radio-button class="button--plain" label="total">全部</el-radio-button>
        <el-radio-button
          class="button--plain" label="point">日常练习</el-radio-button>
        <el-radio-button
          class="button--plain"
          label="question">测评中心</el-radio-button>
      </el-radio-group>
      <el-radio-group v-model="currentTab" style="margin: 30px 0;">
        <el-radio-button class="button--plain" label="name">导出类型: </el-radio-button>
        <el-radio-button class="button--plain" label="total">全部({{totalCount}})</el-radio-button>
        <el-radio-button
          class="button--plain" label="point">知识点巩固练习({{pointCount}})</el-radio-button>
        <el-radio-button
          class="button--plain"
          label="question">错题导出({{questionCount}})</el-radio-button>
      </el-radio-group>
      <test-card :data="item" v-for="item in visibleList" :key="item.id"/>
      <el-pagination
        background
        layout="total, prev, pager, next, jumper"
        :total="currentCount"
        :page-size="pageSize"
        :current-page.sync="currentPage"
        v-if="visibleList.length"
      >
      </el-pagination>
      <empty-content v-if="!visibleList.length" />
    </template>
    <empty-content v-else style="height: 390px" />
  </div>
</template>

<script>
import CardHeader from '@/components/card-header.vue';
import { getTestRecord } from '@/api/pt';
import TestCard from './components/test-card.vue';
import EmptyContent from './components/empty-content.vue';

// const TEACHER_ROLE = 6008003;

const ALL = 'total';
const QUESTION = 2;
const POINT = 1;

export default {
  name: 'TestRecord',
  components: {
    CardHeader,
    TestCard,
    EmptyContent,
  },
  data() {
    // const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO') || '{}');
    return {
      currentTab: ALL, // all|point|question
      sourceTab: ALL,
      total: 0,
      totalCount: 0, // 总数
      pointCount: 0, // 知识点巩固数量
      currentPage: 1,
      pointList: [],
      questionList: [],
      totalList: [], // 总数组
      pageSize: 20,
      isTeacher: true, // 老师和校长操作一致，又改回去了
    };
  },
  computed: {
    questionCount() {
      return this.totalCount - this.pointCount;
    },
    currentType() {
      const typeMap = {
        point: POINT,
        question: QUESTION,
        total: 0,
      };
      console.log(typeMap[this.currentTab], typeMap[this.sourceTab]);
      if (typeMap[this.currentTab] === 0 && typeMap[this.sourceTab] === 0) {
        return 0;
      } if (typeMap[this.currentTab] === 1 && typeMap[this.sourceTab] === 0) {
        return 1;
      } if (typeMap[this.currentTab] === 2 && typeMap[this.sourceTab] === 0) {
        return 2;
      } if (typeMap[this.currentTab] === 0 && typeMap[this.sourceTab] === 1) {
        return 3;
      } if (typeMap[this.currentTab] === 1 && typeMap[this.sourceTab] === 1) {
        return 4;
      } if (typeMap[this.currentTab] === 2 && typeMap[this.sourceTab] === 1) {
        return 5;
      } if (typeMap[this.currentTab] === 0 && typeMap[this.sourceTab] === 2) {
        return 6;
      } if (typeMap[this.currentTab] === 1 && typeMap[this.sourceTab] === 2) {
        return 7;
      }
      return 8;
    },
    currentCount() {
      console.log(`${this.currentTab}Count`, this, `${this.sourceTab}List`);
      return this[`${this.currentTab}Count`];
    },
    // all|知识点巩固练习|错题导出
    visibleList() {
      return this[`${this.currentTab}List`];
    },
  },
  watch: {
    currentPage() {
      this.getTestRecord(this.currentType);
    },
    currentTab() {
      this.currentPage = 1;
    },
    currentType(v) {
      this.getTestRecord(v);
    },
  },
  mounted() {
    this.getTestRecord(this.currentType);
    this.getTestRecord(POINT);
  },
  methods: {
    getTestRecord(type) {
      if (!this.isTeacher) {
        return;
      }
      const typeMap = {
        [POINT]: 'point',
        [QUESTION]: 'question',
        0: 'total',
      };
      getTestRecord({
        curr_page: this.currentPage,
        page_size: this.pageSize,
        type,
      }).then((res) => {
        if (res.code === 200) {
          this[`${typeMap[type]}List`] = res.data.list;
          this[`${typeMap[type]}Count`] = res.data.total;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.p-test-record {
  width: 100%;
  min-height: 100%;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  position: relative;
  /deep/ .button--plain .el-radio-button__inner{
    background: #fff;
    border: 0px solid #fff;
    border-radius: 5px;
    color: #111f2c;
    margin-right: 20px;
    padding: 10px
  }
  /deep/ .button--plain.is-active .el-radio-button__inner {
    background: rgba(25, 137, 250, 1);
    border: 0px solid #fff;
    color: #fff;
    border-radius: 5px;
  }
}
</style>
